<template>
  <div class="flex flex-wrap gap-3">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      :data-chip="opt.value"
      @click="toggle(opt.value)"
      :class="[
        'border rounded-[9px] px-[15px] py-[10px] text-[14px] leading-[14px] text-center transition-colors',
        isSelected(opt.value)
          ? 'chip-selected border-[#489B79] bg-[#489B79] text-white'
          : 'border-[#DADADA] bg-white text-gray-800 hover:border-[#489B79]'
      ]"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ChipMultiSelect",
  props: {
    options: { type: Array, required: true },
    modelValue: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue"],
  methods: {
    isSelected(value) {
      return this.modelValue.includes(value);
    },
    toggle(value) {
      const next = this.isSelected(value)
        ? this.modelValue.filter((v) => v !== value)
        : [...this.modelValue, value];
      this.$emit("update:modelValue", next);
    },
  },
};
</script>
